/*
 created chart.js
*/

import ChartDataLabels from 'chartjs-plugin-datalabels';
import { HorizontalBar, Bar,  Line, Pie, Doughnut, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

let onWheel = (vm) => {
  let chartWrap = document.querySelector(vm.selector);

  vm.chartWidth = Number.parseInt(chartWrap.offsetWidth);
  chartWrap.setAttribute('style', `width: ${vm.chartWidth}px`);

  chartWrap.addEventListener('wheel',  (e) => {

    let width = Number.parseInt(chartWrap.offsetWidth);

    if (width < vm.chartWidth) {
      chartWrap.style.width = `${vm.chartWidth}px`;
    } else {
      if (e.wheelDelta > 0) {
        chartWrap.style.width = `${width + 60}px`;
      } else {
        if (width > vm.chartWidth) {
          chartWrap.style.width = `${width - 60}px`;
        }
      }
    }
  });
};

export const LineChart = {
  extends: Line,
  mixins: [reactiveProp],
  data() {
    return {
      chartWidth: 0,
    };
  },
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    selector: {
      type: String,
      default: null,
    },
  },
  mounted() {
    this.addPlugin(ChartDataLabels);
    this.renderChart(this.chartData, this.options);

    // resize line chart
    if (this.selector) {
      onWheel(this);
    }
  },
};

export const DoughnutChart = {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
  },
  mounted() {
    this.addPlugin(ChartDataLabels);
    this.renderChart(this.chartData, this.options);
  },
};

export const PieChart = {
  extends: Pie,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
  },
  mounted() {
    this.addPlugin(ChartDataLabels);
    this.renderChart(this.chartData, this.options);
  },
};

export const BarChart = {
  extends: HorizontalBar,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
  },
  mounted() {
    this.addPlugin(ChartDataLabels);
    this.renderChart(this.chartData, this.options);
  },
};

export const BarChartDynamic = {
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    selector: {
      type: String,
      default: null,
    },
  },
  mounted() {
    this.addPlugin(ChartDataLabels);
    this.renderChart(this.chartData, this.options);

    // resize line chart
    if (this.selector) {
      onWheel(this);
    }
  },
};
